// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom';
// CUSTOM COMPONENTS
import * as alert from "../../../../redux/alertSnackBarRedux";
// SERVICES AND HELPERS
import * as ReportTypeService from "../../../../services/management/reportTypeService";

const AutomatedReportListingPage = (props) => {
    const { showAlert } = props;
    const [data, setData] = useState([]);

    useEffect(() => {
        loadTableData();
    }, []);

    const loadTableData = () => {
        ReportTypeService.getReports(true).then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <Link
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                to={{
                                    pathname: "/management/automated-report/" + data[dataIndex].id,
                                    state: { reportName: data[dataIndex].name }
                                }}
                            >
                                Manage
                            </Link>
                        </>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Report",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];


    return (
        <>
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Automated Reports
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Automated Reports
                            </span>
                        </h3>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none'
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(null, alert.actions)(AutomatedReportListingPage);